import {
  SurveyValidator,
  SurveyValidatorResult
} from 'core/builder/validators/SurveyValidator'

export class SurveyValidatorBranches extends SurveyValidator {
  static readonly id = {
    target: 'target',
    element: 'element',
    chronological: 'chronological'
  }

  private checkInvalidTargetPage(): SurveyValidatorResult[] {
    return this.survey.pages
      .filter((page) => {
        if (!page.branches || page.branches.length === 0) return false
        return page.branches.some(
          (branch) =>
            !branch.targetPage ||
            !this.survey.pages.some(
              (p) =>
                p.name === branch.targetPage ||
                ['TEMPLATE', 'COMPLETE'].includes(branch.targetPage)
            )
        )
      })
      .map((page) => ({
        pageName: page.name,
        level: 'ERROR',
        description: 'Branch target page is invalid',
        id: SurveyValidatorBranches.id.target
      }))
  }

  private checkInvalidElement(): SurveyValidatorResult[] {
    return this.survey.pages
      .filter((page) => {
        if (!page.branches || page.branches.length === 0) return false
        return page.branches.some((branch) =>
          branch.conditions?.some(
            (c) =>
              !c.elementName ||
              !this.survey.pages
                .find((p) => p.name === page.name)
                ?.elements?.some((e) => e.name === c.elementName)
          )
        )
      })
      .map((page) => ({
        pageName: page.name,
        level: 'ERROR',
        description: 'Branch has invalid condition element',
        id: SurveyValidatorBranches.id.element
      }))
  }

  private checkChronologicalMismatch(): SurveyValidatorResult[] {
    return this.survey.pages
      .filter((page, index) => {
        if (!page.branches || page.branches.length === 0) return false
        return page.branches.some((branch) =>
          this.survey.pages.some(
            (p, i) => p.name === branch.targetPage && i <= index
          )
        )
      })
      .map((page) => ({
        pageName: page.name,
        level: 'WARNING',
        description: 'Branch has chronological mismatch',
        id: SurveyValidatorBranches.id.chronological
      }))
  }

  result(): Promise<SurveyValidatorResult[]> {
    return Promise.resolve([
      ...this.checkInvalidTargetPage(),
      ...this.checkInvalidElement(),
      ...this.checkChronologicalMismatch()
    ])
  }
}
